import { Table, TableProps } from '@pletly/ui';

export type MemberTableProps<MemberData> = Pick<
	TableProps<MemberData>,
	'data' | 'columnsConfig' | 'renderRowActions' | 'onRowPress' | 'rowActionsWidth'
>;

export const MembersTable = <MemberData,>({
	data,
	columnsConfig,
	renderRowActions,
	onRowPress,
	rowActionsWidth = 40,
}: MemberTableProps<MemberData>) => {
	return (
		<Table
			data={data}
			columnsConfig={columnsConfig}
			renderRowActions={renderRowActions}
			rowActionsWidth={rowActionsWidth}
			onRowPress={onRowPress}
		/>
	);
};
